import { useQuery } from "@tanstack/react-query";

import CardIndicator from "./CardIndicator";
import Guests from "./Guests";
import CardPromotion from "./CardPromotion";
import { promotions } from "./fakePromotions";
import proxy from "api/proxy";
import Experiences from "components/Icons/Experiences";
import ContentModalExperience from "ext-apps/WebBookingHotel/Components/ContentModalExperience";

function HouseStatus() {
  async function fetchIndicators() {
    const args = [];
    const model = "dash.app.hotel_frontdesk";
    const method = "indicators";
    const { data } = await proxy.methodCall({ model, method, args });
    return data;
  }

  const { data, isPending } = useQuery({
    queryKey: ["getIndicators"],
    queryFn: fetchIndicators,
  });

  return (
    <div id="house-status">
      <div
        id="indicators"
        className="md:grid md:grid-cols-2 lg:grid-cols-4 pt-6 w-full md:pr-5 max-md:px-5 md:gap-x-4 max-md:space-y-5 max-md:pb-10"
      >
        <CardIndicator
          isPending={isPending}
          nameId="summary"
          title="summary"
          data={data}
        />
        <Guests key="guests" data={data} />
        <CardIndicator
          isPending={isPending}
          nameId="end_day"
          title="end_day"
          data={data}
        />
        <CardIndicator
          isPending={isPending}
          nameId="previous_day"
          title="previous_day"
          data={data}
        />
      </div>
      <div className="mt-8 max-w-screen overflow-hidden max-md:hidden">
        <div className="text-4xl text-neutral-600">
          <span className="font-bold">Upselling</span>
          <span className=""> / Crosselling</span>
        </div>
        <div className="flex mt-8 gap-x-3">
          {/* {promotions.map((pro, idx) => (
            <CardPromotion key={idx} data={pro} />
          ))} */}
        </div>
      </div>
    </div>
  );
}

export default HouseStatus;
